import { Link } from "react-router-dom";

const WORDMARK_SIZES = { sm: "h-8", md: "h-10", lg: "h-16" };
const ICON_SIZES = { sm: "h-9", md: "h-10", lg: "h-14" };

export function Logo({ className = "", to = "/", size = "md", variant = "wordmark" }) {
  const isIcon = variant === "icon";
  const src = isIcon ? "/glexis-icon.webp" : "/glexis-logo.png";
  const height = (isIcon ? ICON_SIZES : WORDMARK_SIZES)[size] || WORDMARK_SIZES.md;
  const alt = isIcon ? "Glexis" : "Glexis — Clarity, Confidence, Control";
  const inner = (
    <img
      src={src}
      alt={alt}
      className={`${height} w-auto object-contain select-none ${className}`}
      draggable={false}
    />
  );
  if (to) {
    return (
      <Link to={to} data-testid="logo-link" aria-label="Glexis home" className="inline-flex">
        {inner}
      </Link>
    );
  }
  return inner;
}
